export default "__VITE_ASSET__B1Sn03qq__"